import React from "react";

const RadioOptionSelector = ({
  selected,
  handleChange,
  radioSelectorProps,
}) => {
  const { containerClassName, titleClassName, title, input1, input2 } =
    radioSelectorProps;

  return (
    <div className="two-radio-selector">
      <p className={`bold ${titleClassName}`}>{title}</p>
      <div
        className={`input-container input-row input-column-gap ${containerClassName}`}
      >
        <div className="no-margin flex-item">
          <input
            id={input1.id}
            name="two-radio-group"
            value={input1.value}
            type="radio"
            className="radio-btn"
            autoComplete="off"
            disabled={input1.disabled}
            checked={selected === input1.value}
            onChange={(event) => handleChange(event)}
          />
          <label className="radio-label" htmlFor={input1.id}></label>
          <label htmlFor={input1.id}>{input1.label}</label>
        </div>
        <div className="no-margin flex-item">
          <input
            id={input2.id}
            name="two-radio-group"
            value={input2.value}
            type="radio"
            className="radio-btn"
            autoComplete="off"
            disabled={input2.disabled}
            checked={selected === input2.value}
            onChange={(event) => handleChange(event)}
          />
          <label className="radio-label" htmlFor={input2.id}></label>
          <label htmlFor={input2.id}>{input2.label}</label>
        </div>
      </div>
    </div>
  );
};

export default RadioOptionSelector;
